module.exports = __webpack_public_path__ + "static/img/banner05.be0896d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner05.jpg
// module id = CzRj
// module chunks = 1